/* Functions to modify user input */
import browser from '@/lib/browser'

/**
 * Capitalizes first letter of each word in the provided string
 *
 * @param str - ID string to be converted
 * @return Resulting title cased string
 */
export function toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

/**
 * Initialize redeem code mask
 */
export function initMask(input: HTMLElement | null): void {
  // Android predictive text causes issues with the mask so there is a workaround
  const isAndroid = browser.isAndroid()

  if (input) {
    import(/* webpackPrefetch: true */ 'inputmask')
      .then(({ default: InputMask }) => {
        // create a mask that separates 4 sets of 4 alphanumeric digits by a '-' character
        const phoneMask = new InputMask({
          mask: '****-****-****-****',
          placeholder: ' ',
          colorMask: isAndroid,
          disablePredictiveText: isAndroid,
          definitions: {
            '*': {
              validator: '[a-zA-Z0-9]',
              casing: 'upper',
            },
          },
        })

        // apply the mask to the input element
        phoneMask.mask(input)
      })
      .catch(() => {})
  }
}
